import { getLang, getLocaleByLang } from '../languages/utils';
import { isLocale } from './utils';
import { type Locale } from './constants';
import { getSupportedLocales } from './getSupportedLocales';

export const getBrowserLocale = (): Locale | null => {
    const browserLang = navigator?.language;
    const supportedLocales = getSupportedLocales();

    const locale = isLocale(browserLang) ? browserLang : getLocaleByLang(getLang(browserLang));

    if (!locale) {
        return null;
    }

    if (supportedLocales.includes(locale)) {
        return locale;
    }

    return null;
};
